var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDownload = function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 18"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "group2420"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "path1645",
    d: "M19 17.999H1a1 1 0 0 1-1-1v-4.423h2v3.423h16v-3.423h2v4.423a1 1 0 0 1-1 1Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "line310",
    d: "M11.338 12h-2V0h2Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "line311",
    d: "m10.419 13.308-1.414-1.414 6.414-6.414 1.414 1.414Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "line312",
    d: "M10.263 13.308 3.849 6.894 5.263 5.48l6.414 6.414Z"
  }))));
};
export default SvgDownload;